import { useContext } from 'react';
import { ThemeContext } from '../../store/ThemeProvider';

// 避免在使用的地方频繁要写上面2个import，哈哈
export default function useTheme() {
  return useContext(ThemeContext);
}
